var React = require('react');

function RightInline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t\t.st0 {\n\t\t\tfill: currentColor;\n\t\t}\n\t"),React.createElement("path",{"className":"st0","d":"M35.5,7.6l-7.1-7.1c-0.4-0.4-1.1-0.6-1.6-0.3c-0.6,0.2-0.9,0.8-0.9,1.4V6c0,0.2-0.2,0.4-0.4,0.4H2.2\n\tC1,6.4,0,7.4,0,8.6c0,1.2,1,2.2,2.2,2.2h23.1c0.2,0,0.4,0.2,0.4,0.4v4.5c0,0.6,0.4,1.2,0.9,1.4c0.6,0.2,1.2,0.1,1.6-0.3l7.1-7.1\n\tC36,9.1,36,8.2,35.5,7.6z","key":1})]);
}

RightInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 35.9 17.3","style":{"enableBackground":"new 0 0 35.9 17.3"},"xmlSpace":"preserve"};

module.exports = RightInline;

RightInline.default = RightInline;
